const services = [
  {
    icon: "ri-car-line",
    title: "Private Vehicle Storage",
    description:
      "Secure, fully-alarmed indoor storage for automobiles of all types — from daily drivers to rare collectibles. Your vehicle stays protected around the clock.",
    image: "https://public.readdy.ai/ai/img_res/cd2decb0948df37d3606bc8385e0e9f5.jpg",
    alt: "Private indoor car storage facility",
  },
  {
    icon: "ri-temp-hot-line",
    title: "Climate-Controlled Protection",
    description:
      "Temperature and humidity monitoring preserves paint, rubber, and interiors against the damaging effects of seasonal Bay Area weather extremes.",
    image: "https://readdy.ai/api/search-image?query=vintage%20motorcycle%20stored%20in%20climate%20controlled%20indoor%20garage%20facility%20with%20polished%20floors%2C%20warm%20golden%20lighting%2C%20dark%20elegant%20atmosphere%2C%20premium%20vehicle%20storage%20editorial%20photography&width=600&height=400&seq=svc002&orientation=landscape",
    alt: "Climate controlled vehicle storage",
  },
  {
    icon: "ri-time-line",
    title: "Long-Term Storage",
    description:
      "Best rates for seasonal and long-term storage. Ideal for collectors, snowbirds, and investment-grade vehicles that deserve sustained preservation.",
    image: "https://readdy.ai/api/search-image?query=row%20of%20classic%20cars%20parked%20inside%20large%20warehouse%20storage%20facility%20with%20high%20ceilings%2C%20industrial%20lighting%2C%20clean%20concrete%20floor%2C%20dark%20moody%20premium%20automobile%20collection%20editorial%20style&width=600&height=400&seq=svc003&orientation=landscape",
    alt: "Long-term vehicle storage",
  },
  {
    icon: "ri-anchor-line",
    title: "RV, Boat &amp; Specialty",
    description:
      "Indoor storage for RVs, boats, trucks, and specialty equipment. Fully alarmed facilities with flexible accommodations for oversized vehicles.",
    image: "https://readdy.ai/api/search-image?query=RV%20and%20boat%20stored%20inside%20large%20indoor%20warehouse%20storage%20facility%20with%20high%20ceilings%2C%20spacious%20clean%20concrete%20floor%2C%20industrial%20warm%20lighting%2C%20professional%20vehicle%20storage%20facility%20photography&width=600&height=400&seq=svc004&orientation=landscape",
    alt: "RV boat and specialty vehicle storage",
  },
];

export default function ServicesOverview() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="bg-[#0F0F0F] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            What We Offer
          </p>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold mb-4">
            Comprehensive Protection Solutions
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto"></div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group bg-charcoal-200 rounded-lg overflow-hidden border border-white/5 hover:border-gold/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={svc.image}
                  alt={svc.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className={`${svc.icon} text-2xl text-gold`}></i>
                </div>
                <h3
                  className="font-serif text-white text-2xl font-semibold mb-3"
                  dangerouslySetInnerHTML={{ __html: svc.title }}
                />
                <p className="font-sans text-[#9A9A9A] text-sm leading-relaxed mb-4">
                  {svc.description}
                </p>
                <button
                  onClick={() => handleScroll("#contact")}
                  className="font-sans text-gold text-sm flex items-center gap-2 hover:gap-3 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Inquire Now
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={() => handleScroll("#contact")}
            className="font-sans text-sm font-semibold border border-gold text-gold px-8 py-4 rounded tracking-wide hover:bg-gold hover:text-charcoal transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            View Storage Options
          </button>
        </div>
      </div>
    </section>
  );
}
